import Fahrdienst from './Fahrdienst.vue';
import FahrdienstHeader from './FahrdienstHeader.vue';
import moduleId from './moduleId';

export const ROUTE_FAHRDIENST = 'ROUTE_FAHRDIENST';
export const ROUTE_FAHRDIENST_DUTY = 'ROUTE_FAHRDIENST_DUTY';
export const ROUTE_FAHRDIENST_DAY = 'ROUTE_FAHRDIENST_DAY';
export const ROUTE_FAHRDIENST_DUTY_DOC = 'ROUTE_FAHRDIENST_DUTY_DOC';
export const ROUTE_FAHRDIENST_DOC_ONLY = 'ROUTE_FAHRDIENST_DOC_ONLY';
class FahrdienstRouteHandler {
  getRoutes = ({ moduleType }) => {
    const initiateSyncBeforeNav = true;
    return [
      {
        // entry page -> search for defaults and displays t
        path: '/fahrdienst/:instance',
        name: ROUTE_FAHRDIENST,
        meta: { moduleType, initiateSyncBeforeNav, moduleId, baseRoute: true },

        components: { default: Fahrdienst, header: FahrdienstHeader },
      },
      {
        path: '/fahrdienst/:instance/:dateYYYYMMDD',
        name: ROUTE_FAHRDIENST_DAY,
        meta: { moduleType, moduleId },

        components: { default: Fahrdienst, header: FahrdienstHeader },
      },
      {
        path: '/fahrdienst/:instance/:dateYYYYMMDD/:dutyId',
        name: ROUTE_FAHRDIENST_DUTY,
        meta: { moduleType, moduleId },

        components: { default: Fahrdienst, header: FahrdienstHeader },
      },
      {
        path: '/fahrdienst/:instance/:dateYYYYMMDD/:documentId/docOnly',
        name: ROUTE_FAHRDIENST_DOC_ONLY,
        meta: { moduleType, moduleId },

        components: { default: Fahrdienst, header: FahrdienstHeader },
      },
      {
        path: '/fahrdienst/:instance/:dateYYYYMMDD/:dutyId/:documentId',
        name: ROUTE_FAHRDIENST_DUTY_DOC,
        meta: { moduleType, moduleId },

        components: { default: Fahrdienst, header: FahrdienstHeader },
      },
    ];
  };
}
const routeHandler = new FahrdienstRouteHandler();
export default routeHandler;
